import { useMemo } from "react"
import { computeFactorCategoryBasedFilters } from "modules/securities-search-parameters/helpers"
import type { FilterOn } from "helpers/filters/filter-ons"
import { SecuritySearchFilter } from "resources/filters"
import { DataStatus, OK } from "helpers/data-statuses"

interface UseFactorFiltersParams {
  categories: unknown[]
  factors: unknown
  filter: SecuritySearchFilter | null
  isOpPro: boolean
  isHistoricalFactorSensitivityAvailable?: boolean | null
}

export function useFactorFilters({ categories, factors, filter, isOpPro, isHistoricalFactorSensitivityAvailable }: UseFactorFiltersParams): [FilterOn[], DataStatus] {
  const filters = useMemo(() =>
    computeFactorCategoryBasedFilters(categories, factors, filter, isOpPro, isHistoricalFactorSensitivityAvailable) as FilterOn[],
  [categories, factors, filter, isOpPro, isHistoricalFactorSensitivityAvailable])

  return [filters, OK]
}
